<template>
  <v-row align="center" justify="center" class="ma-5 pa-5">
    <v-col md="7">
      <v-row align="center" justify="center">
        <v-img src="assets/img/logo.png" max-width="350"></v-img>
      </v-row>
    </v-col>
    <v-col>
      <v-form v-model="formValid" ref="form">
        <v-text-field
          prepend-inner-icon="mdi-email"
          label="E-mail"
          v-model="form.email"
          :rules="emailRules"
        ></v-text-field>
        <v-text-field
          prepend-inner-icon="mdi-lock"
          label="Senha"
          v-model="form.password"
          :rules="passwordRules"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :type="showPassword ? 'text' : 'password'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-btn color="primary" block x-large @click="login">Entrar</v-btn>
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      formValid: true,
      showPassword: false,
      form: {},
      emailRules: [
        (v) => !!v || "É necessário um e-mail",
        (v) => /.+@.+\..+/.test(v) || "O e-mail deve ser válido",
      ],
      passwordRules: [(v) => !!v || "É necessário inserir uma senha"],
    };
  },
  methods: {
    login() {
      this.$refs.form.validate();
      if (this.formValid) {
        this.$store.dispatch("auth/AUTH_REQUEST", this.form);
      }
    },
  },
};
</script>

<style>
</style>